"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patch = patch;
exports.post = post;
exports.put = put;
exports.del = del;

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var doSend = function doSend(type) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return _ImmutableAPI.send.apply(void 0, [{
    type: type,
    headers: {
      'X-Source': _PropertySourceTypes.CRM_UI,
      'X-SourceId': _user.default.get().get('email'),
      'X-Properties-Source': _PropertySourceTypes.CRM_UI,
      'X-Properties-SourceId': _user.default.get().get('email')
    }
  }].concat(args));
};

function patch(url, data, callback) {
  return doSend(_HTTPVerbs.PATCH, url, data, callback);
}

function post(url, data, callback) {
  return doSend(_HTTPVerbs.POST, url, data, callback);
}

function put(url, data, callback) {
  return doSend(_HTTPVerbs.PUT, url, data, callback);
}

function del(url) {
  return doSend(_HTTPVerbs.DELETE, url);
}